<template>
  <div>
    <div class="birth-info">
      <div class="r-text-intro">פרטים אישיים | כמו שמופיעים בת.ז.</div>
      <div class="birth-date">
        <div class="r-text-headline-paragraph">מתי נולדת?</div>
        <birth-date
          :value="birthDate"
          autofocus
          validations="required|notUnderAge|notFuture|dateExists"
          @input="setBirthDate"
          @observe="observe"/>
      </div>

      <div class="birth-country">
        <div class="r-text-headline-paragraph">איפה נולדת?</div>
        <default-autocomplete
                      :value="birthCountry"
                      :options="countries"
                      label="ארץ לידה"
                      :tabindex="10"
                      validations="required"
                      @observe="observe"
                      @input="setBirthCountry"/>
      </div>

    </div>

    <default-button label="הבא >" @click="nextPage" :disable="locked" :loading="locked" />
  </div>
</template>

<script>
import WizardPage from '@/mixins/WizardPage';
import { mapState, mapMutations } from 'vuex';
import Countries from '@/data/Countries';
import BirthDate from '@/components/base/BirthDate';
import DefaultButton from '@/components/styled/DefaultButton';
import DefaultAutocomplete from '@/components/styled/DefaultAutocomplete';

export default {
  name: 'BirthInfo',
  components: { DefaultAutocomplete, DefaultButton, BirthDate },
  mixins: [WizardPage, Countries],
  computed: {
    ...mapState('meitavDash/openFund', ['birthCountry', 'birthDate']),
  },
  methods: {
    ...mapMutations('meitavDash/openFund', ['setBirthDate', 'setBirthCountry']),
  },
};
</script>

<style scoped lang="scss">
.birth-info {
  margin-bottom: 16px;

  .birth-date {
    margin-bottom: 36px;
  }
}

</style>
